import AddIcon from '@mui/icons-material/Add';
import { Button, IconButton } from '@mui/material';
import SourceIcon from '@mui/icons-material/Source';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';

export const forReviewTableHeaders = (handleSourceClick, handleNotesClick) => {
    return [
        {
            id: 'date',
            label: 'Date',
            sort: true,
        },
        {
            id: 'bank_account__name',
            label: 'Account',
            sort: false,
        },
        {
            id: 'description',
            label: 'Description',
            sort: false,
            maxWidth: '500px',
            render: (row) =>
                `${row.description}${
                    row.card_data?.card_number ? ` (x${row.card_data?.card_number})` : ''
                }`,
        },
        {
            id: 'amount',
            label: 'Total',
            sort: false,
            render: (row) => `${row.currency_code} ${row.amount}`,
        },
        {
            id: 'action',
            label: 'Action',
            sort: false,
            render: (row) => (
                <Button>
                    {row?.file_inventory_count
                        ? `${row?.file_inventory_count} Match${
                              row?.file_inventory_count > 1 ? 'es' : ''
                          }`
                        : `Find Match`}
                </Button>
            ),
        },
        {
            id: 'notes',
            label: 'Notes',
            sort: false,
            render: (row) => (
                <IconButton onClick={() => handleNotesClick(row)} sx={{ padding: 0 }}>
                    {row?.inventory_notes && row?.inventory_notes != '' ? (
                        <ChatOutlinedIcon fontSize="small" />
                    ) : (
                        <AddIcon fontSize="small" />
                    )}
                </IconButton>
            ),
        },
        {
            id: 'source',
            label: 'Source',
            sort: false,
            render: (row) => (
                <IconButton onClick={() => handleSourceClick(row)} sx={{ padding: 0 }}>
                    <SourceIcon fontSize="small" />
                </IconButton>
            ),
        },
    ];
};
